import React from 'react'
import { Divider, Flex, Spacer } from '@chakra-ui/react'
import Footer from '_components/Footer'
import AppTour from '_components/Tour'
import TopNav from '_components/AppNav/TopNav'
import SideNav from '_components/AppNav/SideNav'
import Content from '_layout/Content'

function AppWrapper({ children, className, mode = 'normal' }) {
  const isNormal = mode === 'normal'
  return (
    <Flex
      w="full"
      maxW="100vw"
      minH="100vh"
      justify="stretch"
      className={className}
      pl={{ base: '0', md: 'var(--side-nav-width)' }}
      transition="padding-left .15s ease .35s"
      willChange="padding-left"
    >
      {isNormal && (
        <>
          <SideNav />
          <AppTour />
        </>
      )}
      <Flex flex="1 1 100%" direction="column" mt={{ base: 12, md: 0 }} maxW="100%">
        {isNormal && <TopNav />}
        {children}
        <Spacer />
        <Content>
          <Divider mt={{ base: 10, md: 12 }} />
          <Footer mode={mode} />
        </Content>
      </Flex>
    </Flex>
  )
}

export default AppWrapper
